import { createBlock, mergeBlock, t } from "@easy-email-pro-core/utils";

import { ElementCategory, StandardType } from "@easy-email-pro-core/constants";
import {
  ElementDefinition,
  StandardNavbarElement,
} from "@easy-email-pro-core/typings";
import React from "react";
import { Navbar } from "@easy-email-pro-core/components/Elements";
import { omit } from "lodash";

import { Navbar as SourceElement } from "../../basic/Navbar";

const defaultData: ElementDefinition<StandardNavbarElement>["defaultData"] =
  mergeBlock(SourceElement.defaultData, {
    attributes: {
      "item-padding-top": "15px",
      "item-padding-bottom": "15px",
      "item-padding-left": "10px",
      "item-padding-right": "10px",
      color: "#000000",
      "font-family": "Arial",
      "font-size": "13px",
      "font-weight": "normal",
      "line-height": "22px",
      "padding-top": "0",
      "padding-right": "0",
      "padding-bottom": "0",
      "padding-left": "0",
      "letter-spacing": "0px",
      target: "_blank",
      "text-decoration": "none",
      "text-transform": "uppercase",
    },
    data: {},
  });

export const StandardNavbar = createBlock<StandardNavbarElement>({
  get name() {
    return t("Navbar");
  },
  defaultData,
  type: StandardType.STANDARD_NAVBAR,
  create: (payload) => {
    const defaultData: StandardNavbarElement = {
      type: StandardType.STANDARD_NAVBAR,
      data: {},
      attributes: {},
      children: [
        {
          data: {},
          type: "standard-navbar-link",
          children: [
            {
              text: "Shop",
            },
          ],
          attributes: {
            href: "",
          },
        },
        {
          data: {},
          type: "standard-navbar-link",
          children: [
            {
              text: "About",
            },
          ],
          attributes: {
            href: "",
          },
        },
        {
          data: {},
          type: "standard-navbar-link",
          children: [
            {
              text: "Contact",
            },
          ],
          attributes: {
            href: "",
          },
        },
        {
          data: {},
          type: "standard-navbar-link",
          children: [
            {
              text: "Blog",
            },
          ],
          attributes: {
            href: "",
          },
        },
      ],
    };

    return mergeBlock(defaultData, payload);
  },
  category: ElementCategory.NAVBAR,
  render(params) {
    const { node, idx } = params;
    const { ...attributes } = node.attributes;

    if (attributes.direction === "rtl") {
      if (!attributes["css-class"]) {
        attributes["css-class"] = "";
      }
      attributes["css-class"] =
        attributes["css-class"] + " navbar-direction-rtl";
    }

    return (
      <Navbar
        idx={params.idx}
        {...omit(attributes, [
          "color",
          "font-family",
          "font-size",
          "font-style",
          "font-weight",
          "line-height",
          "letter-spacing",
          "text-decoration",
          "text-transform",
          "spacing",
          "item-padding-top",
          "item-padding-bottom",
          "item-padding-left",
          "item-padding-right",
        ])}
        data={node.data}
      >
        {params.children || node.children}
      </Navbar>
    );
  },
});
